import Cookies from "universal-cookie";

const cookies = new Cookies();

export const setCookie = (name: string, value: string) => {
  cookies.set(name, value, { path: "/" });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const removeCookie = (name: string) => {
  cookies.remove(name, { path: "/" });
  // cookies.set(name, "", { path: "/", maxAge: 1 });
};
